import { z } from 'zod';
import { BaseIntegratorDTOSchema, BaseAuthUserDTOSchema } from "./auth.dto.js";
// Schema for delete integrator input
export const DeleteIntegratorInputDTOSchema = z.object({
    integratorId: BaseIntegratorDTOSchema.shape.id,
    deletedBy: BaseAuthUserDTOSchema.shape.id,
});
// Schema for delete integrator output
export const DeleteIntegratorOutputDTOSchema = BaseIntegratorDTOSchema.pick({
    id: true,
    email: true,
}).extend({
    message: z.string(),
});
// Request and response schemas for the API layer
export const DeleteIntegratorRequestDTOSchema = z.object({
    params: z.object({
        id: BaseIntegratorDTOSchema.shape.id,
    }),
});
//# sourceMappingURL=delete-integrator.dto.js.map